import React from "react";

interface UIButtonProps {
  text: string;
  textColor: string;
  isValid?: boolean | null;
  onClick: () => void;
  classButton?: string;
  icon?: string;
  backgroundColor?: string;
  disabled?: boolean;
}

const UIButton: React.FC<UIButtonProps> = ({
  text,
  textColor,
  onClick,
  classButton,
  icon,
  backgroundColor,
  disabled,
}) => {
  return (
    <button
      className={`ui-button ${backgroundColor || ""} ${classButton || ""} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      onClick={onClick}
      disabled={disabled}>
      <span className={textColor}>{text}</span>
      {icon && <img src={icon} alt="icon" />}
    </button>
  );
};

export default UIButton;
